export default __webpack_public_path__ + "static/customer-level-illustration-af7dce23a582a8d43a2d4a6e13cb8dbf.svg";